import React, { useCallback, useState, useEffect } from 'react';
import { Col, Row } from '@thd-olt-component-react/grid';
import PropTypes from 'prop-types';
import { ResultsFilterAndSort } from '../ResultsFilterAndSort';
import '../../styles/results-wrapped.scss';

const NUMBER_OF_ROWS = 2;
const TEXT_OFFSET = 32;
const KPF_OFFSET = 20;

const FONT = '14px helvetica-neue, "Helvetica Neue", Helvetica, Arial, sans-serif';

const getTextWidth = (text = '') => {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  context.font = FONT || getComputedStyle(document.body).font;
  return context.measureText(text).width;
};

const options = ({ numberOfBtn = 0, _label = '', refinements = [] }) => {
  if (!numberOfBtn || !_label.length || !refinements.length) return null;

  return (
    <Row className="KPF-wrapper__block">
      <Col fallback="12" nopadding>
        <div className="KPF-wrapper__title u__bold">{`Choose ${_label}:`}</div>
      </Col>
      <Col className="KPF-wrapper__options">
        {refinements.map((refinement, index) => {
          const { label, url, refinementKey } = refinement || {};
          if (numberOfBtn > (index + 1)) {
            return (
              <div key={refinementKey} className="btn-wrapper">
                <a className="btn-url" href={url}>
                  <span className="btn-text">{label}</span>
                </a>
              </div>
            );
          } if (numberOfBtn === refinements.length) {
            return (
              <div key={refinementKey} className="btn-wrapper">
                <a className="btn-url" href={url}>
                  <span className="btn-text">{label}</span>
                </a>
              </div>
            );
          }
          return null;
        })}
        {
          (numberOfBtn < refinements.length)
            && (
              <button
                type="button"
                key="see-all"
                className="btn-wrapper link"
                onClick={(event) => {
                  if (typeof window !== 'undefined') {
                    window.history.pushState({ page: 'FILTER_SORT_DRAWER', scrollY: window.scrollY }, null, '');
                  }
                  ResultsFilterAndSort.toggleDrawer(_label);
                }}
              >
                <span>+ See All</span>
              </button>
            )
        }
      </Col>
    </Row>
  );
};

const KPFBlock = ({ dimensions, featureIndex, features }) => {
  const [numberOfBtn, setNumberOfBtn] = useState(0);

  let filterList = [];
  filterList = dimensions?.filter((dimension) => {
    const { refinements = [] } = dimension;
    return refinements.find((refinement) => {
      return (features || []).find((feature) => {
        const zIndexValue = parseInt(feature?.refinementId, 10).toString(36);
        return zIndexValue === refinement?.refinementKey;
      });
    });
  });

  const { label = '', refinements = [] } = filterList[featureIndex] || {};

  const calculatePods = useCallback(() => {
    const WRAPPER_WIDTH = typeof (window) !== 'undefined' ? window.innerWidth : 0;
    let btnWidth = 0;
    let numberOfOptions = 0;
    let optionIndex = 0;

    [...Array(NUMBER_OF_ROWS)].forEach((index) => {
      optionIndex = numberOfOptions;
      btnWidth = KPF_OFFSET;
      (refinements || []).forEach((refinement) => {
        const textWidth = getTextWidth(refinement?.label);
        btnWidth = btnWidth + textWidth + TEXT_OFFSET;
        if (WRAPPER_WIDTH > btnWidth) {
          numberOfOptions += 1;
        }
      });
    });
    setNumberOfBtn(numberOfOptions);
    return null;
  }, [refinements]);

  const updatePods = useCallback(() => {
    setNumberOfBtn(0);
    calculatePods();
  }, [calculatePods]);

  useEffect(() => {
    calculatePods();
    window.addEventListener('resize', updatePods);
    return () => window.removeEventListener('resize', updatePods);
  }, [calculatePods, updatePods]);

  if (featureIndex > filterList.length) {
    return null;
  }

  return (
    !!numberOfBtn && options({ numberOfBtn, _label: label, refinements })
  );
};

KPFBlock.propTypes = {
  dimensions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      refinements: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired
        }))
    })
  ).isRequired,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      refinementId: PropTypes.string.isRequired,
      refinementUrl: PropTypes.string.isRequired
    })).isRequired
};

KPFBlock.defaultProps = {
  featureIndex: 0
};

export {
  KPFBlock
};